import { Box, Modal, Typography, useTheme } from '@mui/material';
import { tokens } from '../theme';
import { useTranslation } from '../hooks/useTranslation';
import { Button } from './Button';
import AddCardOutlinedIcon from '@mui/icons-material/AddCardOutlined';

const ModalAfterConsult = ({ open, onClose }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const handleContinue = () => {
    onClose?.();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Box
        sx={{
          backgroundColor: '#fff',
          borderRadius: '16px',
          border: `2px solid ${colors.greenAccent[500]}`,
          p: { xs: '40px 24px', sm: '56px 64px' },
          maxWidth: 560,
          width: '100%',
          boxShadow: '0 24px 64px rgba(0,0,0,0.3)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '24px',
          outline: 'none',
          textAlign: 'center',
          animation: 'fadeSlideUp 0.35s ease',
          '@keyframes fadeSlideUp': {
            from: { opacity: 0, transform: 'translateY(24px)' },
            to: { opacity: 1, transform: 'translateY(0)' },
          },
        }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            backgroundColor: `${colors.greenAccent[500]}22`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: colors.greenAccent[500],
          }}
        >
          <AddCardOutlinedIcon sx={{ fontSize: 40 }} />
        </Box>

        <Typography variant="h3" fontWeight={700} sx={{ color: colors.grey[100] }}>
          {t('onboarding.afterConsult.title')}
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: colors.grey[400], lineHeight: 1.7, maxWidth: 380 }}
        >
          {t('onboarding.afterConsult.description')}
        </Typography>

        <Button
          variant="outlined"
          fullWidth={false}
          onClick={handleContinue}
          sx={{
            fontWeight: 700,
            fontSize: '12px',
            letterSpacing: '0.08em',
            py: '10px',
            borderColor: colors.grey[300],
            color: colors.grey[100],
            '&:hover': {
              borderColor: colors.grey[100],
              backgroundColor: 'transparent',
            },
          }}
        >
          {t('common.continue').toUpperCase()}
        </Button>
      </Box>
    </Modal>
  );
};

export default ModalAfterConsult;
